import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { path } from "ramda";
import HCaptcha from "@hcaptcha/react-hcaptcha";

import useMailinTicketRequestReservation from "./useMailinTicketRequestReservation";
import useFingerprint from "../../lib/useFingerprint";
import Layout from "../Layout";
import Receipt from "./Receipt";
import Form from "./Form";
import { createMailinTicketRequestMutation } from "./gql";
import * as UI from "./ui";

const MailinTicketRequestForm = ({ sweepstakes }) => {
  const [ captcha, setCaptcha ] = useState(null);
  const fingerprint = useFingerprint();
  const [ createMailinTicketRequest, { called, data, loading }] = useMutation(createMailinTicketRequestMutation);
  const { reservation, error: reservationError } = useMailinTicketRequestReservation(sweepstakes.id);

  const mutationError = called && path(['createMailinTicketRequest', 'error', 'message'], data);
  const mailinTicketRequest = path(['createMailinTicketRequest', 'mailinTicketRequest'], data);
  const error = mutationError || reservationError;

  if(mailinTicketRequest) {
    return (
      <Layout.FullWidth fold>
        <Receipt mailinTicketRequest={mailinTicketRequest} sweepstakes={sweepstakes} />
      </Layout.FullWidth>
    );
  }

  const handleSubmit = attributes => {
    createMailinTicketRequest({
      variables: {
        sweepstakesId: sweepstakes.id,
        reservationId: reservation,
        attributes: {
          ...attributes,
          fingerprint,
        },
        captcha,
      }
    })
  };

  return (
    <UI.Layout>
      <UI.Instructions>To receive a sweepstakes entry without a donation, complete this form and follow the instructions on your mailer to print and send in your entry request.</UI.Instructions>
      <UI.Captcha>
        <HCaptcha
          sitekey={import.meta.env.VITE_HCAPTCHA_SITE_KEY}
          onVerify={setCaptcha}
          onExpire={() => setCaptcha(null)}
        />
      </UI.Captcha>
      <Form onSubmit={handleSubmit} disabled={loading || !captcha || !reservation} />
      <Layout.FullWidthColumn>
        { error && <UI.ErrorMessage>{error}</UI.ErrorMessage> }
      </Layout.FullWidthColumn>
    </UI.Layout>
  );
};

export default MailinTicketRequestForm;
